import React from 'react';
import graphql from "graphql";
import PropTypes from 'prop-types';

import baseStyles from './baseStyles';

const TemplateWrapper = ({ data, children }) => (
  <div>
    {baseStyles()}
    <div>{children()}</div>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js